module.exports = __webpack_public_path__ + "static/media/gridView.981310e5.svg";